/* eslint-disable camelcase */
import React from 'react';

import { Form } from 'cvlib';
import { useDispatch, useSelector } from 'react-redux';
import { hidePinForm } from 'containers/PinForm/actions/pinForm.actions';
import { useNavigate, useSearchParams } from 'react-router-dom';

const style = {
  width: '136px',
  height: '40px',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.35rem',
};

const EmailAlertModal = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;

  const elements = [
    {
      element: 'subtitle',
      content: translate('profile_pin_email_confirm_send'),
      style: { paddingTop: '1.75rem' },
    },
    {
      element: 'button',
      type: 'red',
      content: translate('lockChannel_modal_option_button_close'),
      expand: 1,
      style,
      className: 'redButton',
      onClick: () => {
        dispatch(hidePinForm());
        if (searchParams.get('from')) {
          navigate(searchParams.get('from'));
        }
      },
    },
  ];

  return <Form elements={elements} classes={['pin-form-container']} />;
};

export default EmailAlertModal;
